// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".segment-detail .nav-tabs {\n  border: unset !important; }\n  .segment-detail .nav-tabs .nav-link {\n    border: unset;\n    color: gray; }\n    .segment-detail .nav-tabs .nav-link.active {\n      color: #212529; }\n\n.segment-detail .tab-content .content-box {\n  border: unset !important; }\n", ""]);
// Exports
module.exports = exports;
